// @flow

import React, { type Node } from 'react';

import { InformationAccordionBody } from './information-accordion-body';

export function TransferInformation(): Node {
  return <InformationAccordionBody label="Banca" options={OPTIONS} />;
}

const OPTIONS = {
  'BBVA': [
    'Selecciona la opción Pago de Servicios > Instituciones y Emp. > PAGOEFECTIVO',
    'Escoge la cuenta según la moneda e ingresa el código CIP.',
  ],
  'BCP': [
    'Selecciona la opción Pago de Servicios > Empresas diversas > PAGOEFECTIVO',
    'Escoge la cuenta según la moneda e ingresa el código CIP.',
  ],
  'Interbank': [
    'Selecciona la opción Pago de Recibos > Diversas Empresas > Empresa > PagoEfectivo.',
    'En el menú “Servicio” ingresa el código CIP.',
  ],
  'Scotiabank': [
    'Selecciona la opción Pagos – Otras instituciones > Otros',
    'Escoge la institución según la moneda e ingresa el código CIP.',
  ],
  'Caja Arequipa': [
    'Selecciona la opción Pago de Servicios > Busca la entidad PAGOEFECTIVO',
    'Elige la moneda, ingresa el código CIP y sigue los pasos.',
  ],
  'BanBif': [
    'Selecciona la opción Pago de Servicios > Un nuevo pago > PAGOEFECTIVO',
    'Escoge la cuenta según la moneda e ingresa el código CIP.',
  ],
};
